<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>{{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }} Detail</h3>
      <p>
        Informasi detail mengenai
        {{ merchantTypeId == '1' ? 'merchant' : 'sub merchant' }}
      </p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">
            Info {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">
        <v-row>
          <v-col cols="10" sm="4"> Source Onboarding </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.source_onboarding_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Tipe
            {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{
              data == null
                ? ''
                : data.account_type == 'Corporate'
                ? 'Badan Usaha'
                : data.account_type
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Jenis QR </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.qr_type }}
          </v-col>
        </v-row>
        <v-row v-if="data != null && data.id_qr_type == 2">
          <v-col cols="10" sm="4"> Client Version </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.client_version) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor Rekening BNI </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.account_number }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.company_name) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.merchant_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.owner_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.ktp_no) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Nomor NPWP
            {{
              accountType == 'Corporate' ? 'Perusahaan' : 'Pemilik Usaha'
            }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.npwp_no) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Email </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.email }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> No Handphone Pemilik Usaha</v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mobile_phone }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            No Handphone
            {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.merchant_mobile_phone) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            No Telepon {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{
              data == null
                ? ''
                : merchantPhone == ' '
                ? '( not set )'
                : merchantPhone
            }}</v-col
          >
        </v-row>
          <v-row>
          <v-col cols="10" sm="4"> QR Channel </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.channel_qr || '-' }}
          </v-col>
        </v-row>
          <v-row>
          <v-col cols="10" sm="4"> Model Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.merchant_model || '-' }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Jenis Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mcc_name }}
          </v-col>
        </v-row>
        <!-- Dokumen MDR Khusus -->
        <pdf-detail-api
          v-if="data?.custom_mdr_id"
          :documentId="data.custom_mdr_id"
          :filename="data.custom_mdr_filename"
          type="current"
          label="Dokumen MDR Khusus"
        />
        <v-row>
          <v-col cols="10" sm="4"> MDR On-Us </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mdr_on_us + '%' }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> MDR Off-Us </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mdr_off_us + '%' }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Kriteria {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : criteriaText(data.merchant_criteria) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Alamat {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.address }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.kode_pos }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> KODE BC/KO </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.bcko) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Merchant Category Segment </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.cmer) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Referral Code </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.referral_code) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Type Settlement </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.settlement_type_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> MPAN </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mpan }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> ID Approver 1 </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.approver_1 }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> ID Approver 2 </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.approver_2 }}
          </v-col>
        </v-row>

        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          v-if="data != null && data.id_qr_type == 2"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Endpoint</h3>
          </div>
        </v-card>
        <v-row v-if="data != null && data.id_qr_type == 2">
          <v-col cols="10" sm="4"> URL </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.endpoint) }}
          </v-col>
        </v-row>
        <v-row v-if="data != null && data.id_qr_type == 2">
          <v-col cols="10" sm="4"> IP Address </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.ip_address) }}
          </v-col>
        </v-row>
        <!-- SNAP Fields -->
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4"> Callback Partner URL Token </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.access_token_endpoint) }}
          </v-col>
        </v-row>
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4"> Callback Partner ID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.cred_client_id) }}
          </v-col>
        </v-row>
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4"> Callback Partner Client Secret </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.client_secret) }}
          </v-col>
        </v-row>
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4">Public Key Partner</v-col>
          <v-col cols="2" sm="1">:</v-col>
          <v-col cols="12" sm="7">
            <div class="public-key-container">
              <v-textarea
                :value="decryptedPublicKey"
                outlined
                disabled
                dense
                readonly
                rows="3"
                class="fixed-height-textarea"
                hide-details
              />
              <v-btn
                icon
                small
                class="copy-btn"
                @click="copyPublicKey"
                title="Copy Public Key"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Data QR</h3>
          </div>
        </v-card>
        <v-data-table
          :headers="headers"
          :items="qrList"
          :options.sync="options"
          :server-items-length="totalQrList"
          :loading="qrListLoading"
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{}">
            <v-btn
              small
              disabled
              v-if="
                (data != null && data.qr_type.toLowerCase() != 'qr sticker') ||
                isCPTS
              "
            >
              <v-icon class="mr-2"> mdi-printer</v-icon>Print QR
            </v-btn>
            <a
              style="text-decoration: none"
              :download="qrFilename"
              :href="qrisFile"
              v-else
            >
              <v-btn dark small :loading="loadingDocument">
                <v-icon class="mr-2"> mdi-printer</v-icon>Print QR</v-btn
              ></a
            >
          </template>
        </v-data-table>
        <v-row>
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { dataListMerchantCriteria } from '../../../store/params';
import { text, date } from '../../../lib/helpers';
import decryptAES256GCM from '../../../lib/utils/decryptAES';

export default {
  mixins: [validationMixin],
  components: {
    PdfDetailApi: () => import('../../../components/form/PdfDetailApi.vue'),
  },
  validations: {
    remark: { required },
  },
  mounted() {
    this.getDetailData();
  },
  data() {
    return {
      qrListLoading: false,
      remark: '',
      options: null,
      totalQrList: 10,
      qrList: [],
      ktpFile: null,
      npwpFile: null,
      logoFile: null,
      photoFile: null,
      qrisFile: null,
      mounted: false,
      loading: false,
      headers: [
        {
          text: 'NMID',
          sortable: false,
          value: 'nmid',
        },
        {
          text: 'MID',
          sortable: false,
          value: 'mid',
        },
        // {
        //     text: "TID",
        //     sortable: false,
        //     value: "tid",
        // },
        {
          text: 'QR Type',
          sortable: false,
          value: 'qr_type',
        },
        {
          text: 'Status',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      search: {},
      criteriaMerchantText: dataListMerchantCriteria,
      loadingDocument: false,
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.loading) {
          this.getListQR();
        }
      },
      deep: true,
    },
  },
  computed: {
    data() {
      return this.$store.state.client.merchant.merchant;
    },
    isCPTS() {
      return this.data.id_qr_type == 8;
    },
    accountType() {
      return this.data != null ? this.data.account_type : null;
    },
    remarkErrors() {
      const errors = [];
      if (!this.$v.remark.$dirty) {
        return errors;
      }
      if (!this.$v.remark.required) errors.push('Remark is required.');
      return errors;
    },
    photoFilename() {
      return `Foto-Merchant-${date}-${this.$route.params.id}.jpg`;
    },
    qrFilename() {
      return `QR-Merchant-${date}-${this.$route.params.id}`;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    isApiSnap() {
      if (this.data == null) return false;
      // eslint-disable-next-line eqeqeq
      return this.data.id_qr_type == 2 && this.data.client_version === 'SNAP';
    },
    decryptedPublicKey() {
      if (!this.isApiSnap || !this.data.public_key_inbound) return '';
      try {
        return decryptAES256GCM(this.data.public_key_inbound);
      } catch (e) {
        // If decryption fails, return original value
        return this.data.public_key_inbound;
      }
    },
  },
  methods: {
    criteriaText(value) {
      const find = this.criteriaMerchantText.find((x) => value == x.value);
      return find != undefined ? find.text : value;
    },

    async getDetailData() {
      this.loading = true;

      await this.$store
        .dispatch('client/merchant/viewMerchant', {
          id: this.$route.params.id,
          date,
        })
        .then(() => {
          if (this.data == null) {
            throw this.data;
          }
        })
        .catch(() => {
          this.$router.back();
        });
      if ( this.data?.qr_type?.toLowerCase() == 'qr sticker' ) {
        this.loadingDocument = true;
        this.$store
          .dispatch('client/merchant/viewDocument', {
            id: this.$route.params.id,
            doc_type: '4',
            type: 'current',
            download: '0',
            date,
          })
          .then((response) => {
            if (response != null) {
              if (
                response.replace('data:image/jpg;base64,', '') == '' ||
              response.replace('data:image/png;base64,', '') == ''
              ) {
                this.qrisFile = null;
              } else {
                this.qrisFile = response;
              }
            }
          })
          .finally(() => {
            this.loadingDocument = false;
          });
      }
      this.loading = false;
    },

    async getListQR() {
      this.qrListLoading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      await this.$store
        .dispatch('client/merchant/getQRList', {
          id: this.$route.params.id,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          date,
        })
        .then((response) => {
          if (response != null) {
            this.qrList = response.list;
            this.totalQrList = parseInt(response.countdata, 10);
          }
        })
        .finally(() => {
          this.qrListLoading = false;
        });
    },

    back() {
      this.$router.back();
    },

    async copyPublicKey() {
      try {
        await navigator.clipboard.writeText(this.decryptedPublicKey);
        this.$toast.success('Public Key copied to clipboard');
      } catch (err) {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = this.decryptedPublicKey;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$toast.success('Public Key copied to clipboard');
      }
    },

    text,
  },
};
</script>

<style scoped>
.fixed-height-textarea ::v-deep .v-input__slot {
  max-height: 100px !important;
}

.fixed-height-textarea ::v-deep textarea {
  line-height: 1.2;
  font-family: monospace;
  overflow-y: auto !important;
}

.public-key-container {
  position: relative;
  width: 100%;
}

.copy-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  z-index: 1;
}

.copy-btn:hover {
  background-color: #e0e0e0 !important;
}
</style>
